import script from "./dynamicTreeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamicTreeTable.vue?vue&type=script&setup=true&lang=js"

import "./dynamicTreeTable.vue?vue&type=style&index=0&id=a58ab500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a58ab500"]])

export default __exports__